export {
  RecipePage as default,
  getStaticProps,
  getStaticPaths,
} from "@chef/feature-recipe";
